import type { LoanApplication } from '@/types/LoanApplicationType';

/**
 * True when the application record was saved after the user last attested.
 * Backend should bump `updatedAt` on substantive PATCHes; attestation POST should
 * set `acceptedAt` and align `updatedAt` so edits after sign invalidate.
 */
export function isLoanAttestationSupersededByEdits(
  app: LoanApplication
): boolean {
  const acceptedAt = app.signAttestation?.acceptedAt;
  if (!acceptedAt) return false;
  const updatedAt = app.updatedAt;
  if (!updatedAt) return false;
  return new Date(updatedAt).getTime() > new Date(acceptedAt).getTime();
}

/** User must (re-)open the attestation flow and submit. */
export function loanAttestationNeedsRecording(app: LoanApplication): boolean {
  if (!app.signAttestation?.acceptedAt) return true;
  return isLoanAttestationSupersededByEdits(app);
}

/** Attestation on file and still matches latest application save. */
export function loanAttestationIsCurrent(app: LoanApplication): boolean {
  return (
    Boolean(app.signAttestation?.acceptedAt) &&
    !isLoanAttestationSupersededByEdits(app)
  );
}
